import config from '@packages/common/config';

export function formatTime(date, format) {
    if (typeof date === 'string') {
        var mts = date.match(/(\/Date\((\d+)\)\/)/);
        if (mts && mts.length >= 3) {
            date = parseInt(mts[2]);
        }
    }
    date = new Date(date);
    if (!date || date.toUTCString() == 'Invalid Date') {
        return '';
    }
    var map = {
        M: date.getMonth() + 1, // 月份
        d: date.getDate(), // 日
        h: date.getHours(), // 小时
        m: date.getMinutes(), // 分
        s: date.getSeconds(), // 秒
        q: Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
    };
    format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
        var v = map[t];
        if (v !== undefined) {
            if (all.length > 1) {
                v = '0' + v;
                v = v.substr(v.length - 2);
            }
            return v;
        } else if (t === 'y') {
            return (date.getFullYear() + '').substr(4 - all.length);
        }
        return all;
    });
    return format;
}
export function getDzzxUrl(params, isPreview) {
    const tokenName = window.dazeRunningConfing
        ? window.dazeRunningConfing.DAZE_APPLICATION_TOKEN_NAME || 'accessToken'
        : 'accessToken';
    let url = `${config.dzzxHost}${isPreview ? 'preview/' : ''}?t=${localStorage.getItem(tokenName)}&from=shopmanager`;
    Object.keys(params).forEach((key) => {
        url += `&${key}=${params[key]}`;
    });
    return url;
}
export function getStringLen(str) {
    var temp = 0;
    for (var i = 0; i < str.length; i++) {
        if (/[\u0391-\uFFE5]/.test(str[i])) {
            // /[u0391-uFFE5]/
            temp += 2;
        } else {
            temp++;
        }
    }
    return temp;
}
export function deepClone(params) {
    // 深拷贝
    const obj = Array.isArray(params) ? [] : {};
    for (const attr in params) {
        if (typeof params[attr] === 'object') {
            obj[attr] = params[attr] === null ? params[attr] : deepClone(params[attr]);
            continue;
        }
        obj[attr] = params[attr];
    }
    return obj;
}
export function timeFn(d1) {
    // di作为一个变量传进来
    // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    var dateBegin = d1; // 将-转化为/，使用new Date
    var dateEnd = new Date(); // 获取当前时间
    var dateDiff = dateEnd.getTime() - dateBegin.getTime(); // 时间差的毫秒数
    // var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); // 计算出相差天数
    // var leave1 = dateDiff % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
    // var hours = Math.floor(leave1 / (3600 * 1000)); // 计算出小时数
    // 计算相差分钟数
    // var leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
    // var minutes = Math.floor(leave2 / (60 * 1000)); // 计算相差分钟数
    // 计算相差秒数
    // var leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
    // var seconds = Math.round(leave3 / 1000);
    return dateDiff;
    /* console.log(" 相差 "+dayDiff+"天 "+hours+"小时 "+minutes+" 分钟"+seconds+" 秒")
    console.log(dateDiff+"时间差的毫秒数",dayDiff+"计算出相差天数",leave1+"计算天数后剩余的毫秒数"
        ,hours+"计算出小时数",minutes+"计算相差分钟数",seconds+"计算相差秒数");*/
}
export function timeFn2(d1) {
    // di作为一个变量传进来
    // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    var dateBegin = d1; // 将-转化为/，使用new Date
    var dateEnd = new Date(); // 获取当前时间
    var dateDiff = dateBegin.getTime() - dateEnd.getTime(); // 时间差的毫秒数
    return dateDiff;
}
// 补零
export function formatNumber(n) {
    n = n.toString();
    return n[1] ? n : '0' + n;
}
// 时间戳格式化 formatTimestap(timestamp,'y-m-d h:m:s')
export function formatTimestamp(timestamp, format) {
    const time = new Date(timestamp);
    const newArr = [];
    const formatArr = ['y', 'M', 'd', 'h', 'm', 's'];
    newArr.push(time.getFullYear());
    // eslint-disable-next-line no-undef
    newArr.push(utils.formatNumber(time.getMonth() + 1));
    // eslint-disable-next-line no-undef
    newArr.push(utils.formatNumber(time.getDate()));
    // eslint-disable-next-line no-undef
    newArr.push(utils.formatNumber(time.getHours()));
    // eslint-disable-next-line no-undef
    newArr.push(utils.formatNumber(time.getMinutes()));
    // eslint-disable-next-line no-undef
    newArr.push(utils.formatNumber(time.getSeconds()));

    for (const i in newArr) {
        format = format.replace(formatArr[i], newArr[i]);
    }
    return format;
}
/**
 * @description:格式化价格
 * @param {pointNum: 小数点位数, maxNum: 最大数} pointNum 等于0 或为空时 返回整数值
 * @return: 处理后的价格
 */
export function formatPrice(e, pointNum, maxNum) {
    var val = e;
    if (!pointNum) {
        pointNum = 0;
    }
    const pattern = new RegExp(`^\\d*\\.?\\d{0,${pointNum}}$`);
    // var pattern = /^\d*\.?\d{0,2}$/;
    if (pointNum > 0) {
        let num = 1;
        for (let i = 0; i < pointNum; i++) {
            num += '0';
        }
        num = Number(num);
        if (!pattern.test(val)) {
            const s = parseFloat(val);
            val = isNaN(s) ? 0 : Math.floor(s * num) / num;
        }
        if (isNaN(val)) {
            val = '';
        }
        const regex = /^[0]+/;
        val = val + '';
        const valArr = val.split('');
        if (regex.test(val) && valArr.length > 1 && valArr[1] != '.') {
            val = val.replace(regex, '');
        }
        if (regex.test(val) && valArr.length > 1 && valArr[1] == '0') {
            val = val.replace(regex, 0);
        }
    } else {
        val = Math.ceil(val);
    }
    if (val > maxNum && maxNum) {
        val = maxNum;
    }
    return val;
}
/**
 * @description: 获取产品价格
 * @param {el: v2 接口获取后的 产品数据}
 * @return: 返回产品价格
 */
export function getOfferPriceRange(el) {
    let price = '';
    if (el.SaleInfo.priceRanges != null) {
        const priceRanges = el.SaleInfo.priceRanges;
        if (priceRanges.length > 1) {
            // 区间
            price = priceRanges[priceRanges.length - 1].price.toFixed(2) + '~' + priceRanges[0].price.toFixed(2);
        } else {
            price = priceRanges[0].price.toFixed(2);
        }
    }
    return price;
}

export function uuid() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';

    var uuid = s.join('');
    return uuid;
}

export const toCDB = (str) => {
    // 全角空格转半角
    var tmp = '';
    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) == 12288) {
            tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
            continue;
        }
        if (str.charCodeAt(i) == 160) {
            // 把连接符空格ASCII 160 改为正常的空格32
            tmp += String.fromCharCode(str.charCodeAt(i) - 128);
            continue;
        } else {
            tmp += String.fromCharCode(str.charCodeAt(i));
        }
        // else if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
        //   tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
        // }
    }
    return tmp;
};
